module.exports = __webpack_public_path__ + "img/hero_image_speaker_messages.c690d99.jpg";